import NchLogoStackedBase from "./FieldTypeBase/NchLogoStackedBase";
import Col from '../Col2.js';

const NchLogoStackedBlock = (props) => {
    return(

         <Col
            {...props}
            className={`nchLogoStackedBlock ${props.field.class || ""} col-md-${props.field.width}`}
            key={props.objectkey} 
            id={props.objectkey}>
              
                <NchLogoStackedBase {...props} />             

          </Col>
    );
}
export default NchLogoStackedBlock;